import { makeStyles } from '@material-ui/core';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const PLUGridSpacing = '0.3vw';

// adding all breakpoints here to make future design changes easier
const quickViewWidth = {
  '@media (min-width: 1020px)': {
    width: '24vw',
  },
  '@media (min-width: 1020px) and (max-width: 1100px) and (min-height: 760px)': {
    width: '25.4vw',
  },
  '@media (min-width: 1150px)': {
    width: '24vw',
  },
  '@media (min-width: 1300px)': {
    width: '24vw',
  },
  '@media (min-width: 1500px)': {
    width: '21vw',
  },
  '@media (min-height: 999px)': {
    width: '24vw',
  },
};

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles = makeStyles((theme: any) => ({
  hidden: {
    display: 'none',
  },

  leftHanded: {
    marginRight: '1.1vw',
    marginLeft: '0 !important',
  },

  overflowEllipsis: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  quickView: {
    backgroundColor: themeColor.white,
    border: `1px solid ${themeColor.secondaryLight}`,
    height: '100%',
    width: '25.4vw',
    marginRight: '1.1vw',
    ...quickViewWidth,
  },

  quickViewToggleButton: {
    padding: 0,
    width: '25.4vw',
    margin: '-1px -1px 0 -1px',
    ...quickViewWidth,
  },

  quickViewToggleButtonLabel: {
    alignItems: 'center',
    justifyContent: 'center',
    ...quickViewWidth,
  },

  mainContainer: {
    height: '100%',
    width: 0,
    flexGrow: 1,
    alignContent: 'flex-start',
  },

  scrollButton: {
    minWidth: '4.09vw',
  },

  pluMenu: {
    marginBottom: '1.9vh',
  },

  bottomBar: {
    marginTop: '2.6vh',
    justifyContent: 'space-between',
  },

  bottomBarGroup: {
    display: 'flex',
  },

  paginationContainer: {
    paddingLeft: '2.3vw',
  },

  smallerPaginationpadding: {
    paddingLeft: '1.05vw',
  },

  // PLU Grid
  pluGridContainer: {
    position: 'relative',
    flexGrow: 1,
    overflow: 'hidden',
  },

  pluGrid: {
    position: 'absolute',
    width: 'calc(100% + 0.6vw)',
    height: 'calc(100% + 0.6vw)',
    marginLeft: `-${PLUGridSpacing}`,
    marginTop: `-${PLUGridSpacing}`,
    alignContent: 'flex-start',
  },

  pluContainer: {
    flexGrow: 1,
  },

  pluContents: {
    width: 0,
    flexGrow: 1,
  },

  pluGridItem: {
    height: '20%',
    padding: PLUGridSpacing,
    '& > button': {
      color: theme.palette.secondary.main,
      width: '100%',
      height: '100%',
      padding: 0,
      '& > span': {
        width: '100%',
        height: '100%',
      },
    },
  },

  productContainer: {
    flexGrow: 1,
    padding: '0.7vh 0.3vh',
    borderRadius: '2px',
    border: `1px solid ${themeColor.secondaryLight}`,
    backgroundColor: themeColor.white,
    textAlign: 'start',
    '&:hover': {
      cursor: 'pointer',
    },
  },

  productImage: {
    aspectRatio: '1',
    overflow: 'hidden',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },

  productDetailParentContainer: {
    position: 'relative',
    width: 'auto',
    flexGrow: 1,
    overflow: 'hidden',
  },

  productDetailContainer: {
    position: 'absolute',
    paddingLeft: '0.6vw',
    height: '100%',
    justifyContent: 'space-between',
  },

  description: {
    textTransform: 'none',
    color: themeColor.defaultTextColor,
    '@media (max-height: 580px)': {
      fontSize: rem(0.75),
    },
  },

  price: {
    fontSize: rem(0.75),
    lineHeight: 1.2,
    letterSpacing: 0.75,
    color: themeColor.palesky,
    marginRight: '0.5vw',
    '@media (max-height: 580px)': {
      fontSize: rem(0.6),
    },
  },

  quantityContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'nowrap',
  },

  quantity: {
    color: theme.palette.secondary.main,
    fontSize: rem(0.75),
    lineHeight: 1.2,
    letterSpacing: 0.5,
    fontWeight: 500,
    paddingRight: '0.3vw',
    '@media (max-height: 580px)': {
      fontSize: rem(0.6),
    },
  },

  badge: {
    color: theme.palette.primary.main,
    paddingBottom: '0.39vh',
  },

  // Sales Keypad
  salesKeypadContainer: {
    position: 'relative',
    width: '25.4vw',
    alignContent: 'flex-end',
    marginLeft: '1.1vw',
    '@media (min-width: 1020px)': {
      width: '21.6vw',
    },
    '@media (min-width: 1020px) and (max-width: 1100px) and (min-height: 760px)': {
      width: '25.4vw',
    },
    '@media (min-width: 1150px)': {
      width: '22vw',
    },
    '@media (min-width: 1300px)': {
      width: '22.5vw',
    },
    '@media (min-width: 1500px)': {
      width: '21vw',
    },
    '@media (min-height: 999px)': {
      width: '22.5vw',
    },
  },

  salesKeypad: {
    position: 'absolute',
    display: 'grid',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    alignContent: 'end',
  },

  salesKeypadFlexContainer: {
    width: '100%',
    maxHeight: '100%',
    margin: 'auto',
    aspectRatio: '0.53',
    overflow: 'hidden',
    boxSizing: 'border-box',
    position: 'relative',
    display: 'flex',
    alignItems: 'end',
    '@media (min-width: 1020px)': {
      aspectRatio: '0.58',
    },
    '@media (min-width: 1020px) and (max-width: 1100px) and (min-height: 760px)': {
      aspectRatio: '0.53',
    },
    '@media (min-width: 1150px)': {
      aspectRatio: '0.575',
    },
    '@media (min-width: 1300px)': {
      aspectRatio: '0.58',
    },
    '@media (min-width: 1500px)': {
      aspectRatio: '0.55',
    },
    '@media (min-height: 999px)': {
      aspectRatio: '0.5',
    },
  },

  productDisplaySalesKeypad: {
    position: 'absolute',
    top: '33vh',
    right: '2vw',
  },

  finishButton: {
    fontSize: vh(2.08),
    '& > div': {
      color: themeColor.white,
    },
    '@media (aspect-ratio: 4/3)': {
      width: '8.536vw',
    },
  },

  keypadButton: {
    marginLeft: '1.1vw',
    '& > div': {
      color: themeColor.white,
    },
  },

  // Menus
  tab: {
    minWidth: 0,
    '& span': {
      fontSize: vh(1.82),
      fontWeight: 500,
      lineHeight: '1.82vh',
      letterSpacing: '0.05vw',
    },
  },

  categoryBorder: {
    borderBottom: `1px solid ${themeColor.borderGray}`,
  },

  secondLevelTab: {
    backgroundColor: themeColor.white,
    marginRight: 10,
    borderRadius: 2,
    border: `1px solid ${themeColor.secondaryLight}`,
    height: '7.29vh',
    color: theme.palette.info.dark,
    letterSpacing: '0.02vw',
    lineHeight: '2.6vh',
    minWidth: 0,
    maxWidth: '8.8vw',
    padding: '0 1.5vw',
    '& span': {
      fontSize: vh(1.82),
      textTransform: 'capitalize',
      color: themeColor.defaultTextColor,
    },
    '&.Mui-selected': {
      border: `solid ${theme?.configColors?.secondaryColor || themeColor.secondaryMain}`,
      color: themeColor.defaultTextColor,
    },
  },
}));
